import React from "react";
import parseWithIcons from "../../utils/parseWithIcons";

const ContenuDynamiqueImage = ({ data }) => {
  let className = "center";

  if (data.placementDeLimage === "gauche") {
    className = "left";
  } else if (data.placementDeLimage === "droite") {
    className = "right";
  }

  return (
    <div className="dynamic image">
      <div className="inner">
        <div className={`image ` + className}>
          {data.image && (
            <figure>
              <picture>
                <source
                  type="image/webp"
                  srcSet={data.image.localFile.childImageSharp.fluid.srcWebp}
                  data-srcset={
                    data.image.localFile.childImageSharp.fluid.srcSetWebp
                  }
                />
                <source
                  type="image/jpeg"
                  srcSet={data.image.localFile.childImageSharp.fluid.src}
                />
                <img
                  src={data.image.localFile.childImageSharp.fluid.src}
                  alt={data.image.altText}
                />
              </picture>
              {data.description && (
                <figcaption className="desc">
                  {parseWithIcons(data.description)}
                </figcaption>
              )}
            </figure>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContenuDynamiqueImage;
